import {
  MAX_FULL_NAME_LENGTH,
  MAX_NAME_LENGTH,
  MAX_PASSWORD_LENGTH,
  MIN_AGE,
  MIN_PASSWORD_LENGTH,
} from '@/constants/Common'
const constant = {
  emailInvalid: 'Invalid email address.',
  emailRequired: 'Email is required.',
  passRequired: 'Password is required.',
  passNoWhiteSpace: 'Whitespace is not allowed.',
  passMinLength: `Password must be at least ${MIN_PASSWORD_LENGTH} characters long.`,
  passMaxLength: `Password must not exceed ${MAX_PASSWORD_LENGTH} characters.`,
  passLettersNumbers: 'Password must contain letters and numbers',
  passOneNumbers: 'Password must contain at least one number',
  passStrength: `A minimum ${MIN_PASSWORD_LENGTH} characters password containing a combination of uppercase or lowercase letters and numbers are required.`,
  passMatch: 'Please enter a matching password.',
  fullNameRequired: 'Full name is required.',
  fullNameNoSpecial: 'No numbers or special characters are allowed.',
  fullNameNoWhitespace: 'Only whitespaces are not allowed.',
  fullNameMaxLength: `Only ${MAX_FULL_NAME_LENGTH} characters are allowed`,
  nameMaxLength: `Only ${MAX_NAME_LENGTH} characters are allowed`,
  typeDate: 'Date format should be MM/DD/YYYY.',
  birthDateRequired: 'Birth date is required.',
  birthDateMin: `Minimum age is ${MIN_AGE} years old.`,
  emailConfirm: 'Emails do not match.',
  locationRequired: 'Location is required',
  locationNeedsCity: 'Please choose a city or town. A country on its own is not enough.',
  locationSaveFailed: 'We could not use that location. Try again or pick another one.',
}

export type LocaleConstant = typeof constant

export default constant
